function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.21015 16.7525C4.041 15.6353 1.56685 11.35 2.68397 7.18082C3.80109 3.01168 8.08645 0.537518 12.2556 1.65464C16.4247 2.77176 18.8989 7.05713 17.7818 11.2263C16.6647 15.3954 12.3793 17.8696 8.21015 16.7525Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.59 15.5782L19.9998 22.7911",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgSearch = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Search.a3b3be0f.svg";
export { ForwardRef as ReactComponent };